import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router';
import Header from './ui/components/organism/header.jsx';
import Footer from './ui/components/organism/footer.jsx';
import BodyAbout from './ui/components/templates/bodyabout.jsx';
import BodyThematic from './ui/components/templates/bodythematic.jsx';
import BodyDecorations from './ui/components/templates/bodydecorations.jsx';
import BodyInvitations from './ui/components/templates/bodyinvitations.jsx';
import BodyContact from './ui/components/templates/bodycontact.jsx';
import BodySketch from './ui/components/templates/bodysketch.jsx';
import BodyLogin from './ui/components/templates/bodylogin.jsx';
import BodyDecorationPost from './ui/components/templates/bodydecorationcreate.jsx';
import BodyTerms from './ui/components/templates/bodyterms.jsx';
import BodyEventBooking from './ui/components/templates/bodybookingcreate.jsx';
import BodyBookingDetail from './ui/components/templates/bodybookingdetail.jsx';
import { Root } from './ui/utils/global.js';
import { LABEL, URL } from './ui/utils/constants.js';
import { 
    FontUnicornsAreAwesome,
    FontNoteworthyLight,
    FontNoteworthyBold,
    FontAvenirBook,
    FontAvenirBlack,
    FontAvenirHeavy,
    FontAvenirMedium,
    FontAvenirLight
} from './ui/utils/fonts.js';
import ProtectedRoute from './ui/utils/protectedRoute.js';


// Fix re-use by using key property to reload decorations screen when navigate from same screen.
// React uses the key to decide whether to 're-use' or 'remount'
const BodyDecorationsWrapper = () => {
    const { typeCode } = useParams();
    return <BodyDecorations key={typeCode} />;
};

const App = () => {
     return(
     <div>
        <Root/>
        <FontUnicornsAreAwesome/>
        <FontNoteworthyLight/>
        <FontNoteworthyBold/>
        <FontAvenirBook/>
        <FontAvenirBlack/>
        <FontAvenirHeavy/>
        <FontAvenirMedium/>
        <FontAvenirLight/>

        <Router>
            <Routes>

                <Route exact path={URL.home} element={
                    <div>
                        <Header selected={LABEL.init}/>
                        <BodyAbout/>
                    </div>
                }/>

                <Route path={URL.thematics} element={
                    <div>
                        <Header selected={LABEL.thematics}/>
                        <BodyThematic/>
                    </div>
                }/>

                <Route path={URL.decorations} element={
                    <div>
                        <BodyDecorationsWrapper/>
                    </div>
                }/>

                <Route path={URL.sketch} element={
                    <div>
                        <Header selected={LABEL.sketch}/>
                        <BodySketch/>
                    </div>
                }/>

                <Route path={URL.invitations} element={
                    <div>
                        <Header selected={LABEL.invitations}/>
                        <BodyInvitations/>
                    </div>
                }/>

                <Route path={URL.contact} element={
                    <div>
                        <Header selected={LABEL.contact}/>
                        <BodyContact/>
                    </div>
                }/>

                <Route path={URL.login} element={
                    <div>
                        <Header/>
                        <BodyLogin/>
                    </div>
                }/>

                <Route element={<ProtectedRoute/>}>
                    <Route path={URL.decorationCreate} element={
                        <div>
                            <Header/>
                            <BodyDecorationPost/>
                        </div>
                    }/>
                </Route>

                <Route path={URL.terms} element={
                    <div>
                        <Header/>
                        <BodyTerms/>
                    </div>
                }/>

                <Route path={URL.bookingCreate} element={
                    <div>
                        <Header/>
                        <BodyEventBooking/>
                    </div>
                }/>

                <Route path={URL.bookingDetail} element={
                    <div>
                        <Header/>
                        <BodyBookingDetail/>
                    </div>
                }/>

            </Routes>
        </Router>

        <Footer/>
    </div>
    );
}

export default App;